// CR49
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import InfoIcon from '@wix/da-ds/pkg/Icons/24x24/Info';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import {
  formatDate,
  DATE_FORMATS,
} from '@wix/da-shared-react/pkg/Timestamp/functions';

import s from './Deviousness.scss';

export interface Props {
  className?: string;
  moduleId: number;
  moduleVersion: number;
  dateAwarded: string;
  description: string;
}

const Deviousness: React.FC<Props> = ({
  className,
  dateAwarded,
  description,
}) => {
  const { t } = useTranslation();

  return (
    <div className={classnames(s['root'], className)}>
      <div className={s['box']}>
        <a
          className={s['info-link']}
          href="https://www.deviantartsupport.com/en/article/what-is-the-deviousness-award"
          rel="noopener noreferrer nofollow"
          target="_blank"
        >
          <InfoIcon
            className={s['info-icon']}
            size={IconSize.MEDIUM}
            condensed
          />
        </a>
        <div className={s['crown']} />
        <div className={s['description']}>
          <div
            className={s['dd-text']}
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />
        </div>
        <div className={s['award-date']}>
          {t('widgets.deviousness.awarded', {
            timestamp: formatDate(dateAwarded, DATE_FORMATS.Date.MonthYear),
          })}
        </div>
      </div>
    </div>
  );
};
Deviousness.displayName = 'Deviousness';

export default Deviousness;
